import { Grid, MenuItem, Select, TextField } from '@mui/material';
import { createRef } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { CostType, CostWeightType } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getCostType } from '../calculationTypes';
import { getSelectedCalculationPricelistCurrency } from '../redux/calculationSelectors';

type OwnProps = {
    handleNameChange: (val: string) => void;
    handleAmountChange: (val: number) => void;
    name: string;
    amount: number;
    costWeightType?: CostWeightType;
    handleCostWeightTypeChanged: (val: number) => void;
    currency: string;
};

const mapStateToProps = (state: RootState) => ({
    isEditCostDialogLoading: state.calculation.isEditCostDialogLoading,
    currency: getSelectedCalculationPricelistCurrency(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PricePerPriceUnitCostDialogContent = ({
    isEditCostDialogLoading,
    handleAmountChange,
    handleNameChange,
    name,
    amount,
    currency,
    costWeightType,
    handleCostWeightTypeChanged
}: Props) => {
    const getAmountLabel = () => {
        return getCostType(currency, CostType.PriceUnit);
    };
    const amountInputRef = createRef();
    return (
        <div>
            <Grid container direction="column">
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth={true}
                    onChange={e => handleNameChange(e.target.value)}
                    value={name}
                    disabled={isEditCostDialogLoading}
                />

                <NumberFormat
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    sx={{ marginTop: '12px' }}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    placeholder="Amount"
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix={` ${getAmountLabel()}`}
                />

                <Select
                    fullWidth
                    value={costWeightType ?? CostWeightType.GrossWeight}
                    label="Calculate on weight type"
                    sx={{ marginTop: '12px' }}
                    onChange={e => handleCostWeightTypeChanged(e.target.value as CostWeightType)}
                >
                    <MenuItem key={CostWeightType.GrossWeight} value={CostWeightType.GrossWeight}>
                        Gross weight
                    </MenuItem>
                    <MenuItem key={CostWeightType.NetWeight} value={CostWeightType.NetWeight}>
                        Net weight
                    </MenuItem>
                </Select>
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(PricePerPriceUnitCostDialogContent);
